// 수학 문제은행 화면(MathBankPage)과 출제 설정 창(MathBankAssignModal)이 같이 쓰는 값 · 함수.
// 서버: api/assignment/math_bank.py, math_bank_views.py

export const DB_OPTION_LIST = [
  { value: "mine", label: "내 문제" },
  { value: "public", label: "문제은행" },
];
export const SOURCE_OPTION_LIST = [
  { value: "both", label: "원본 + 변형" },
  { value: "original", label: "원본" },
  { value: "twin", label: "변형" },
];
export const KIND_LABEL = { choice: "객관식", short: "주관식", essay: "서술형" };
// 복습 문제(2026-11-03 대표). 쌍둥이는 수학 사이트의 닮은 문제를 받는다(서버 math_bank_review.py)
export const REVIEW_PROBLEM_OPTION_LIST = [
  { value: "twin", label: "쌍둥이 문제" },
  { value: "same_problem", label: "틀린 문제 그대로" },
];
export const REVIEW_DIFFICULTY_OPTION_LIST = [
  { value: "auto", label: "채점 보고 자동" },
  { value: "same", label: "같게" },
  { value: "easier", label: "더 쉽게" },
  { value: "harder", label: "더 어렵게" },
];
// 보통 학습지 중 쌍둥이 복습을 고를 수 있는 종류(서버 TWIN_REVIEW_MATH_TYPE_LIST 와 같다)
export const TWIN_REVIEW_MATH_TYPE_LIST = ["type_worksheet", "variant"];
// 한 번에 낼 수 있는 문제 수(서버 BANK_PICK_MAX_TOTAL 과 같다)
export const MAX_TOTAL = 100;

// 미리 보기용으로 수식 글자를 읽을 만하게 편다. 학생 화면처럼 그리지는 않는다(교사 앱에 수식 입력기가 없다)
const SUPERSCRIPT_BY_DIGIT = { 0: "⁰", 1: "¹", 2: "²", 3: "³", 4: "⁴", 5: "⁵", 6: "⁶", 7: "⁷", 8: "⁸", 9: "⁹" };
// 분자 · 분모가 숫자나 글자 하나면 괄호 없이 쓴다(2/3). 식이면 괄호로 묶는다((a+1)/2)
const fractionPartOf = (part) => (/^[\w.]+$/.test(part.trim()) ? part.trim() : `(${part})`);
const LATEX_REPLACE_LIST = [
  // 띄어쓰기 명령(\, \; \! \ ). 남겨 두면 '3\,×\,5' 처럼 보인다
  [/\\[,;:! ]/g, " "],
  [/\\left|\\right/g, ""],
  [/\\d?frac\{([^{}]*)\}\{([^{}]*)\}/g, (_, top, bottom) => `${fractionPartOf(top)}/${fractionPartOf(bottom)}`],
  [/\\sqrt\{([^{}]*)\}/g, "√($1)"],
  [/\\times/g, "×"],
  [/\\div/g, "÷"],
  [/\\pm/g, "±"],
  [/\\leq?/g, "≤"],
  [/\\geq?/g, "≥"],
  [/\\neq?/g, "≠"],
  [/\\cdot/g, "·"],
  [/\\pi/g, "π"],
  [/\\angle/g, "∠"],
  [/\\triangle/g, "△"],
  [/\^\{(\d+)\}/g, (_, digits) => [...digits].map((digit) => SUPERSCRIPT_BY_DIGIT[digit]).join("")],
  [/\^(\d)/g, (_, digit) => SUPERSCRIPT_BY_DIGIT[digit]],
  [/\^\{([^{}]*)\}/g, "^$1"],
  [/\\[a-zA-Z]+/g, ""],
  [/[{}$]/g, ""],
];
export const plainMathText = (text) =>
  LATEX_REPLACE_LIST.reduce((result, [pattern, replacement]) => result.replace(pattern, replacement), String(text || ""))
    .replace(/〈그림:\d+〉/g, "")
    .replace(/\s+/g, " ")
    .trim();

export const imageListOf = (problem) => problem.image_urls || (problem.image_url ? [problem.image_url] : []);
